import { differenceInYears } from 'date-fns';
import { GlobalState } from 'little-state-machine';

export function updateFormStateAction(state: GlobalState, payload) {
  return {
    ...state,
    riderForm: {
      ...state.riderForm,
      ...payload,
    },
  };
}

export function updatePassengersContactsAttributesAction(state: GlobalState, payload) {
  return {
    ...state,
    riderForm: {
      ...state.riderForm,
      passengersContactsAttributes: Array.isArray(payload) ? payload : [payload],
    },
  };
}

export function updatePassengersResidenceAttributesAction(state: GlobalState, payload) {
  return {
    ...state,
    riderForm: {
      ...state.riderForm,
      residence: payload.residence,
      residenceMustBeMet: payload.residenceMustBeMet,
      residenceMustBeMetProtocol: payload.residenceMustBeMetProtocol,
    },
  };
}

export function clearAction() {
  return {
    riderForm: {
      firstName: '',
      lastName: '',
      dateOfBirth: null,
      gender: '',
      boosterSeat: false,
      frontSeatAuthorized: false,
      mustBeMet: false,
      residenceMustBeMet: false,
      residenceMustBeMetProtocol: {
        locationProtocol: '',
        authorizedContactGroups: [],
      },
      category: '',
      isAide: false,
      school: {},
      residence: {},
      codeWord: '',
      riderNotes: '',
      passengersContactsAttributes: [{ firstName: '', lastName: '', role: '', relationship: '', phoneNumber: '' }],
      mobilePhoneNumber: '',
      externalId: '',
      photosAttributes: [{ attachment: new File([], '') }],
      email: '',
      isSharedBillingRider: false,
      sharedBillingRider: {
        residenceAccountContactName: '',
        residenceAccountContactEmail: '',
        residenceAccountId: null,
        residenceAccountContactId: null,
      },
      services: [],
      // Local flag only - NOT sent to API
      usedSisImport: false,
    },
  };
}

export function checkSafetySettings(state: GlobalState, payload) {
  const hasDOBChanged = state.riderForm.dateOfBirth?.toDateString() !== payload.dateOfBirth.toDateString();
  const age = hasDOBChanged && differenceInYears(Date.now(), new Date(payload.dateOfBirth));

  const { services, ...rest } = payload;

  const isCSServiceAvailable = services.some((service) => service.code === 'CS' && service.available);

  return {
    ...state,
    riderForm: {
      ...state.riderForm,
      ...rest,
      ...(age && {
        boosterSeat: (!isCSServiceAvailable && age === 6) || !!(age > 6 && age <= 8),
      }),
    },
  };
}
